import React, { Component } from 'react'
import IconComponent from './IconComponent'

class RefreshComponent extends Component {
  /**
   * RefreshComponent constructor.
   *
   * @param {object} props
   */
  constructor(props) {
    super(props)

    this.state = { clicked: false }
  }

  /**
   * Toggle clicked class.
   */
  toggleClicked() {
    this.setState({ clicked: false }, () => {
      setTimeout(() => this.setState({ clicked: true }), 0)
    })
  }

  /**
   * On click refresh action.
   */
  handleClickRefresh() {
    this.toggleClicked()
    this.props.actionOnClickRefresh()
  }

  /**
   * Render.
   *
   * @return {XML}
   */
  render() {
    const clicked = this.state.clicked ? 'clicked' : ''

    return <IconComponent icon="sync-alt" className={'refresh ' + clicked} onClick={() => this.handleClickRefresh()} />
  }
}

export default RefreshComponent
